<template>
    <div class="data-table">
        <b-table
            v-bind="$attrs"
            v-on="$listeners"
            :per-page="currentPerPage"
            :current-page="currentPage"

            ref="data_table"
        >
            <template #table-busy>
                <Loader />
            </template>

            <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
            <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData"
                ><slot :name="name" v-bind="slotData"
            /></template>
        </b-table>

        <div v-if="enableTotalRows && totalRows > 0 && showRichTable" class="total-rows text-muted mb-2 text-left">
            {{ $tc("table.pagination.total", totalRows, [totalRows]) }}
        </div>
        <div v-if="enablePagination && totalRows > minPerPage && showRichTable" class="text-left">
            <div class="d-inline-block">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="currentPerPage"
                    class="mb-0"
                ></b-pagination>
            </div>

            <label class="mx-2">{{ $t("table.pagination.label") }}</label>

            <div class="d-inline-block">
                <b-form-select v-model="currentPerPage" :options="pageOptions"></b-form-select>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from "@/components/Loader.vue";

export default {
    inheritAttrs: false,
    props: {
        enablePagination: { type: Boolean, default: true },
        enableTotalRows: { type: Boolean, default: true },
        showRichTable: { type: Boolean, default: true },
        pageOptions: { type: Array, default: () => [10, 20, 50] },
        perPage: { type: Number, default: 10 },
        startPage: { type: Number, default: 1 },
    },
    data: function() {
        return {
            currentPage: 1,
            totalRows: 0,
            currentPerPage: 10,
        };
    },
    components: { Loader },
    computed: {
        minPerPage: function() {
            return Math.min(...this.pageOptions);
        },
    },
    created: function() {
        this.currentPerPage = this.perPage;
        this.currentPage = this.startPage;
    },
    methods: {
        refresh: function() {
            this.$refs.data_table.refresh();
        },
        setTotalRows: function(count) {
            this.totalRows = count;
        },
    },
};
</script>

<style lang="scss">
@import "src/scss/bootstrap-table";
.data-table {
    table {
        @include style-bootstrap-table();

        .absorbing-column {
            width: 100%;
        }
        .column-20 {
            width: 20%;
        }
    }
}
</style>
